<template>
  <div class="manage-content">
    <div class="page-title mt-10">
      Distributors
    </div>
    <div class="page-content mt-20" v-loading="loading">
      <el-collapse v-if="data.length">
        <el-collapse-item
          :name="distributor.DistributorId"
          v-for="distributor in data"
          :key="distributor.DistributorId"
        >
          <template slot="title">
            <b>Distributor: {{ distributor.DistributorName }}</b>
          </template>
          <el-table border size="small" :data="distributor.Organisations">
            <el-table-column
              label="Organisation Name"
              prop="OrganisationName"
            ></el-table-column>
            <el-table-column
              label="Domain Name"
              prop="DomainName"
            ></el-table-column>
            <el-table-column
              label="Organisation Address"
              prop="OrganisationAddress"
            ></el-table-column>
            <el-table-column
              label="Organisation Contact"
              prop="OrganisationContact"
            ></el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
      <div v-else class="no-data v-h-center min-h-300">No Distributors</div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'
import ApiService from '@/services/ReportApiService.js'
import moment from 'moment'
export default {
  data() {
    return {
      moment,
      data: [],
      loading: false,
      user: JSON.parse(localStorage.getItem('user'))
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      ApiService.GetAllOrganisations(this.filter)
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.data = response.data.data
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>
